import { render, staticRenderFns } from "./ResearchSingleCellBrowser.vue?vue&type=template&id=b4b584cc&scoped=true"
import script from "./ResearchSingleCellBrowser.vue?vue&type=script&lang=js"
export * from "./ResearchSingleCellBrowser.vue?vue&type=script&lang=js"
import style0 from "./ResearchSingleCellBrowser.vue?vue&type=style&index=0&id=b4b584cc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b584cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4b584cc')) {
      api.createRecord('b4b584cc', component.options)
    } else {
      api.reload('b4b584cc', component.options)
    }
    module.hot.accept("./ResearchSingleCellBrowser.vue?vue&type=template&id=b4b584cc&scoped=true", function () {
      api.rerender('b4b584cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/singleCellBrowser/ResearchSingleCellBrowser.vue"
export default component.exports